module.exports = __webpack_public_path__ + "static/img/3.1bd722b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/plans/snip3down/3.png
// module id = 04Ve
// module chunks = 35